import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'
import useInvoice from '@hooks/useInvoice'

import type { CampaignModel } from '@models/types'

import UploadBillImage from '../../assets/bill.svg'

const UploadBillButton = (props: { campaign: CampaignModel }) => {
  const { campaign } = props

  const invoice = {
    approved: true,
    campaign_id: campaign.id,
    created_by: 'debtor',
    debtor_id: campaign.agency_id,
    debtor_type: 'Agency',
  }

  const { callbacks: { createAgencyPayableInvoice } } = useInvoice(invoice)

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        marginTop: 'medium',
        padding: 'large',
      }}
      onClick={() => createAgencyPayableInvoice()}
      forceBottomBorder
      showAngleIcon
    >
      <Image backgroundSize="contain" url={UploadBillImage} width={40} height={40} />

      <Box flexDirection="column" marginLeft="large">
        <Text>Upload Bill</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">Upload a bill to keep as a record</Text>
      </Box>
    </ListItem>
  )
}
export default UploadBillButton
